import { FETCH_ZONE, GET_ZONE, CREATE_ZONE, UPDATE_ZONE, DELETE_ZONE } from 'actions/address';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  zones: [],
  zoneDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const zoneReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ZONE.REQUEST:
    case GET_ZONE.REQUEST:
    case CREATE_ZONE.REQUEST:
    case DELETE_ZONE.REQUEST: {
      return { ...state, isLoading: true, zoneDetail: {} };
    }

    case UPDATE_ZONE: {
      return { ...state, isLoading: true };
    }

    case FETCH_ZONE.SUCCESS: {
      if (payload.page === 1) {
        return {
          ...state,
          isLoading: false,
          zones: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          zones: _.concat(state.zones, payload.results),
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      }
    }

    case GET_ZONE.SUCCESS: {
      return {
        ...state,
        zoneDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_ZONE.SUCCESS: {
      toast.success('Zone added successfully');
      return {
        ...state,
        zones: _.concat(state.zones, payload),
        isLoading: false,
      };
    }

    case UPDATE_ZONE.SUCCESS: {
      toast.success('Zone updated successfully');
      return {
        ...state,
        zones: state.zones.map((data) => (data.id === payload.id ? payload : data)),
        isLoading: false,
      };
    }

    case DELETE_ZONE.SUCCESS: {
      toast.success('Zone deleted successfully');
      return {
        ...state,
        zones: state.zones.filter((data) => data.id !== payload),
      };
    }

    case FETCH_ZONE.FAIL:
    case GET_ZONE.FAIL:
    case CREATE_ZONE.FAIL:
    case UPDATE_ZONE.FAIL:
    case DELETE_ZONE.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default zoneReducer;
